/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ConnectAzureRestoreAccountRequest {
  /**
  * The tenant ID. This field is required. 
  */
  'tenantId': string;
  /**
  * The subscription ID. This field is required. 
  */
  'subscriptionId'?: string;
  /**
  * The resource group name. 
  */
  'resourceGroupName'?: string;
  /**
  * The location of the backup account. This field is required. e.g. \"eastus\" 
  */
  'location'?: string;
  /**
  * Resource group name for Eon\'s temporary internal resources. 
  */
  'eonInternalResourceGroupName'?: string;
  /**
  * Optional display name for the account. 
  */
  'name'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "subscriptionId",
      "baseName": "subscriptionId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "resourceGroupName",
      "baseName": "resourceGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": ""
    },
    {
      "name": "eonInternalResourceGroupName",
      "baseName": "eonInternalResourceGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectAzureRestoreAccountRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

